import { http } from '../shared/api';

export const getAiRun = (fiscalYear, config) => http.get(
  '/api/climate-action/ai-runs',
  { ...config, params: { fiscal_year: fiscalYear } },
);

export const generateAiRun = (fiscalYear) => http.post(
  '/api/climate-action/ai-runs',
  { fiscal_year: fiscalYear },
);

export const dismissAiSource = (fiscalYear, sourceKey) => http.post(
  `/api/climate-action/ai-runs/${fiscalYear}/dismiss`,
  { source_key: sourceKey },
);

export const undoDismissAiSource = (fiscalYear, sourceKey) => http.post(
  `/api/climate-action/ai-runs/${fiscalYear}/undo-dismiss`,
  { source_key: sourceKey },
);